module.exports = "https://static.cdns.space/tarot-temp/img/the-devil.357f307e.webp";